import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert } from '@mui/material';
import { CurrencyInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  currencyToUpdate: CurrencyInterface | null;
  setCurrencyToUpdate: React.Dispatch<React.SetStateAction<CurrencyInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
  updateSuccess?: string | null;
}

export const CurrenciesAdminUpdateDialog: React.FC<Props> = ({
  open,
  currencyToUpdate,
  setCurrencyToUpdate,
  onClose,
  onSave,
  updateError,
  updateSuccess,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update Currency</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
      <TextField
        label="Code"
        value={currencyToUpdate?.code ?? ''}
        onChange={e => setCurrencyToUpdate(c => c ? { ...c, code: e.target.value } : c)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Name"
        value={currencyToUpdate?.name ?? ''}
        onChange={e => setCurrencyToUpdate(c => c ? { ...c, name: e.target.value } : c)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Symbol"
        value={currencyToUpdate?.symbol ?? ''}
        onChange={e => setCurrencyToUpdate(c => c ? { ...c, symbol: e.target.value } : c)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Rate"
        type="number"
        value={currencyToUpdate?.rate === 0 ? '' : currencyToUpdate?.rate ?? ''}
        onChange={e => {
          const value = e.target.value === '' ? 0 : Number(e.target.value);
          setCurrencyToUpdate(c => c ? { ...c, rate: value } : c);
        }}
        fullWidth
        margin="dense"
        required
        inputProps={{ step: '0.0001' }}
      />
      <FormControl fullWidth margin="dense">
        <InputLabel id="active-label">Active</InputLabel>
        <Select
          labelId="active-label"
          value={currencyToUpdate?.active !== undefined ? (currencyToUpdate.active ? 'yes' : 'no') : 'yes'}
          label="Active"
          onChange={e => setCurrencyToUpdate(c => c ? { ...c, active: e.target.value === 'yes' } : c)}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);